import { push } from 'connected-react-router';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { ROUTES } from '../auth.constants';
import { SplashScreen } from '../splash-screen/splash-screen';
import { TIME_WAITING_FOR_GOOGLE_OPTIMIZE_REDIRECTION } from './sign-up-loading.constants';


type SignUpLoadingProps = {
    pushTo: (path: string)=> void,
    maxTimeWaitingForGoogleOptimizeRedirection: number,
}

const SignUpLoadingImpl = ({
    pushTo,
    maxTimeWaitingForGoogleOptimizeRedirection = TIME_WAITING_FOR_GOOGLE_OPTIMIZE_REDIRECTION,
}: SignUpLoadingProps) => {
    useEffect(() => {
        setTimeout(() => {
            pushTo(ROUTES.SIGN_UP);
        }, maxTimeWaitingForGoogleOptimizeRedirection);
    }, [maxTimeWaitingForGoogleOptimizeRedirection, pushTo]);

    return (<SplashScreen error={null} showSignOutButton={false} />);
};

export const enhancers = connect(
    null, dispatch => bindActionCreators({ pushTo: push }, dispatch),
);


export const SignUpLoading = compose(enhancers)(SignUpLoadingImpl);
